import * as React from "react";
import { connect, Dispatch } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import FormElements from "../../FormElements";

import { RootState } from "../../../redux";

const Input = FormElements.Inputs.Input1;

import DialogButtonContainer from "../../DialogComponents/Buttons/ButtonContainer";
import DialogButton from "../../DialogComponents/Buttons/Button";


interface IInvitePatientFormProps {
    onSubmit: (fields: InvitePatientFields) => any;
    handleSubmit?: React.FormEventHandler<any>;
    onCloseDialog: () => any;
    doctor: boolean;
}

interface IConnectProps {
    placeId: string;
    isEditingBar: boolean;
    isAddingBar: boolean;
}

interface State {
}

export interface InvitePatientFields {
    phone: string;
}

const s = require("./InviteUserForm.scss");

class InviteUserForm extends React.Component<IInvitePatientFormProps & IConnectProps, State> {
    refs: {form: HTMLFormElement};

    render(): JSX.Element {
        return (
            <form ref="form" className={s.form} onSubmit={this.props.handleSubmit}>
                <h2>Convidar {(this.props.doctor) ? "médico" : "paciente"}</h2>

                <label className={s.row}>
                    <span className={s.label}>Número de telefone:</span>
                    <Field
                        name="phone"
                        component={Input}
                    />
                </label>

                <DialogButtonContainer>
                    <DialogButton type="reset" onClick={this.props.onCloseDialog}>
                        Cancelar
                    </DialogButton>

                    <DialogButton type="submit">
                        {this.props.placeId ? (this.props.isEditingBar ? "Editando..." : "Editar") : (this.props.isAddingBar ? "Adicionando..." : "Adicionar")}
                    </DialogButton>
                </DialogButtonContainer>
            </form>
        );
    }
}

const InvitePatientFormForm = reduxForm({
  form: "InvitePatientFormForm",
})(InviteUserForm);

const selector = formValueSelector("InvitePatientFormForm");
export default connect<{}, {}, IInvitePatientFormProps>((state: RootState) => ({
    placeId: selector(state, "id"),
}))(InvitePatientFormForm);



// WEBPACK FOOTER //
// ./src/components/Forms/InviteUserForm/index.tsx